var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_4616_4335)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 33C32 31.6044 32 30.9067 31.8278 30.3389C31.44 29.0605 30.4395 28.06 29.1611 27.6722C28.5933 27.5 27.8956 27.5 26.5 27.5H21.5C20.1044 27.5 19.4067 27.5 18.8389 27.6722C17.5605 28.06 16.56 29.0605 16.1722 30.3389C16 30.9067 16 31.6044 16 33M28.5 19.5C28.5 21.9853 26.4853 24 24 24C21.5147 24 19.5 21.9853 19.5 19.5C19.5 17.0147 21.5147 15 24 15C26.4853 15 28.5 17.0147 28.5 19.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4616_4335",
    x1: -67.5,
    y1: -30,
    x2: 4.47661,
    y2: -59.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F2D7F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.6663b490bb8da8f43ac475758e5585d9.svg";
export { ForwardRef as ReactComponent };